import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { describeDelta, type DeltaDirection } from '@/lib/reportFormat';

interface StatTileProps {
  label: string;
  /** The figure, as it is to be read. */
  value: string;
  /** The figure and the one before it, as numbers, to compare them. */
  current: number;
  previous: number;
  /** A line under the figure that says more about it. */
  detail?: string;
}

const DELTA_ICONS: Record<DeltaDirection, React.ElementType | null> = {
  up: ArrowUpRight,
  down: ArrowDownRight,
  same: Minus,
  none: null,
};

/** A headline figure, and how it compares with the period before. */
export default function StatTile({ label, value, current, previous, detail }: StatTileProps) {
  const delta = describeDelta(current, previous);
  const Icon = DELTA_ICONS[delta.direction];

  return (
    <div className="card p-4 flex flex-col gap-1" role="group" aria-label={label}>
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <p className="text-2xl font-bold text-foreground tabular-nums">{value}</p>
      <p className="flex items-center gap-1 text-xs text-muted-foreground">
        {Icon && <Icon className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />}
        {delta.text}
      </p>
      {detail && <p className="text-xs text-muted-foreground">{detail}</p>}
    </div>
  );
}
